export type OrderViewModel = {
    id: string,
    orderLineId: string,
    name: string,
    address: string,
    amount: number,
    deliveryDue: Date,
    status: string,
}

export type MyAccountState = Readonly<{
    openOrders: OrderViewModel[] | undefined;
    completedOrders: OrderViewModel[] | undefined;
    totalOpenOrders: number;
    totalCompletedOrders: number;
    isLoading: boolean;
    lastLoaded: Date | undefined;
}>;

export const initialState: MyAccountState = {
    openOrders: undefined,
    completedOrders: undefined,
    totalOpenOrders: 0,
    totalCompletedOrders: 0,
    isLoading: false,
    lastLoaded: undefined,
};

export default MyAccountState;